import { styled } from 'stitches.config'

export const WeightLossRoot = styled('div', {
  width: '100%',
  background: '$tertiary-200',
  padding: '64px 0px',

  '@bp2': {
    padding: '77px 0px',
  },
})

export const WeightLossContainer = styled('div', {})
export const ButtonWrapper = styled('div', {
  marginTop: '42px',
  display: 'flex',
  justifyContent: 'center',
  '@bp2': {
    justifyContent: 'center',
  },
})
